exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3YrNihnPcNYSStHFCTVjYP{top:-11px;position:relative}._36CbeMUul160_BaOc004Od{font-size:11px;font-weight:400;color:\"[theme:neutralSecondary, default:#605e5c]\"}html[dir] ._36CbeMUul160_BaOc004Od{padding:0}html[dir=ltr] ._36CbeMUul160_BaOc004Od{margin-right:6px}html[dir=rtl] ._36CbeMUul160_BaOc004Od{margin-left:6px}._25PDIRwPTbbCvgI4wMWgWF:hover{color:\"[theme:themePrimary, default:#0078D4]\"}", ""]);
// Exports
exports.locals = {
	"attachmentWellBar": "_3YrNihnPcNYSStHFCTVjYP",
	"barButton": "_36CbeMUul160_BaOc004Od",
	"barButtonHover": "_25PDIRwPTbbCvgI4wMWgWF"
};